"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { getStorySpotlightViewerState, recordChapterCompletion } from "@/lib/actions/spotlight-actions";
import type { StorySpotlightState } from "@/lib/spotlights/queries";
import { SpotlightControl } from "@/components/spotlights/spotlight-control";
export function ChapterEndSpotlight(t0) {
  const $ = _c(10);
  const {
    storyId,
    chapterId,
    initialState,
    isAuthenticated
  } = t0;
  const sentinelRef = useRef(null);
  const [state, setState] = useState(initialState);
  const isOwnStory = initialState.isOwnStory;
  let t1;
  let t2;
  if ($[0] !== chapterId || $[1] !== isAuthenticated || $[2] !== isOwnStory || $[3] !== storyId) {
    t1 = () => {
      const sentinel = sentinelRef.current;
      if (!sentinel || !isAuthenticated || isOwnStory) {
        return;
      }
      let hasRecorded = false;
      let isRecording = false;
      const observer = new IntersectionObserver(entries => {
        if (hasRecorded || isRecording || !entries.some(_temp)) {
          return;
        }
        isRecording = true;
        recordChapterCompletion(chapterId).then(async result => {
          if ("error" in result) {
            isRecording = false;
            return;
          }
          hasRecorded = true;
          observer.disconnect();
          setState(await getStorySpotlightViewerState(storyId));
        });
      }, {
        threshold: 0.75
      });
      observer.observe(sentinel);
      return () => observer.disconnect();
    };
    t2 = [chapterId, isAuthenticated, isOwnStory, storyId];
    $[0] = chapterId;
    $[1] = isAuthenticated;
    $[2] = isOwnStory;
    $[3] = storyId;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  const t3 = `${state.totalXp}:${state.isQualified}:${state.weeklyAllowance}`;
  let t4;
  if ($[6] !== state || $[7] !== storyId || $[8] !== t3) {
    t4 = <div ref={sentinelRef} className="mt-16 min-h-px scroll-mt-24"><SpotlightControl key={t3} storyId={storyId} initialState={state} compact={true} /></div>;
    $[6] = state;
    $[7] = storyId;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp(entry) {
  return entry.isIntersecting;
}